import { createApp } from "vue";
import App from "./App.vue";
import "survey-core/survey-core.min.css";

const app = createApp(App);
app.mount("#app");